import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Modal, Carousel } from "react-bootstrap";

const FacilityData = ({ facility }) => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (!facility) {
      navigate("/facility-list");
    }
  }, [facility, navigate]);

  if (!facility) return null;

  const {
    name,
    fid,
    location: loc,
    description,
    images = [],
    rent = [],
    amenities = [],
    terms_conditions: terms,
    instructions,
    advance_booking: advanceBooking,
    cancellationPolicy,
    capacity,
  } = facility;
  const validRent = rent.filter(
    (r) => r.purpose !== "Not Specified" && Number(r.amount) > 0
  );

  const capitalizeFirstLetter = (str) => {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  return (
    <main className="d-flex justify-content-center px-3 py-2">
      <div
        className="dashbord property-info"
        style={{
          maxWidth: "900px",
          width: "100%",
          background: "#fff",
          padding: "8px",
          borderRadius: "12px",
          boxShadow: "0 4px 15px rgba(0,0,0,0.08)",
        }}
      >
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12 text-center mb-4">
              <div className="d-flex align-items-center justify-content-between">
                <button
                  className="d-flex align-items-center backbutton"
                  style={{
                    borderRadius: "5px",
                    backgroundColor: "#eb2a25",
                    color: "white",
                    width: '105px'
                  }}
                  onClick={() => navigate("/dashboard")}
                >
                  <i className="fa fa-arrow-left me-2"></i> Back
                </button>
                <div className="d-flex align-items-center">
                  <h1 className="m-0" style={{ color: "#eb2a25", paddingLeft: '5px' }}>
                    {name}
                  </h1>
                  &nbsp;&nbsp;
                  <h5>
                    <strong>{fid}</strong>
                  </h5>
                </div>
                {/* <div style={{ width: "80px" }}></div> */}
              </div>
            </div>

            {images.length > 0 && (
              <div className="col-md-12 mb-3 text-center">
                <div style={{ position: "relative" }}>
                  <img
                    src={images[0]}
                    alt="Main Facility"
                    style={{
                      width: "100%",
                      maxHeight: "400px",
                      objectFit: "cover",
                      borderRadius: "12px",
                    }}
                  />
                  {images.length > 1 && (
                    <div
                      style={{
                        position: "absolute",
                        top: "15px",
                        right: "15px",
                        zIndex: 1,
                      }}
                    >
                      <button className="more_photos"
                        onClick={() => setShowModal(true)}
                        style={{

                        }}
                      >
                        More Photos
                      </button>
                    </div>
                  )}
                </div>
              </div>
            )}

            <div className="col-md-12 text-center mb-4">
              <p className="text-muted mb-1">
                <i className="fa fa-map-marker me-2"></i> {loc}
              </p>
              <p className="text-muted mb-0">
                <i className="fa fa-users me-2"></i> {capacity} Capacity
              </p>
            </div>

            <div className="col-md-12 mb-4">
              <div className="textblockdetails">
                <h5>About this Facility</h5>
                <div
                  dangerouslySetInnerHTML={{
                    __html: description
                  }}
                />
                {/* <p style={{ whiteSpace: 'pre-wrap' }}>
                                            {item.description}
                                        </p> */}

              </div>
            </div>

            {validRent.length > 0 && (
              <div className="col-md-12 mb-4">
                <h5 className="mb-3">Rent Per Hour</h5>
                <div className="renthr">
                  <table
                    className="table table-hover align-middle w-100"
                    style={{ border: "1px solid #eee", borderRadius: "4px" }}
                  >
                    <thead className="thead-light">
                      <tr>
                        <th>Purpose</th>
                        <th>Day</th>
                        <th>Time</th>
                        <th>Rent</th>
                        <th>Min Duration</th>
                        <th>Start Date</th>
                        <th>End Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {validRent.map((r, idx) => (
                        <tr key={idx}>
                          <td>{capitalizeFirstLetter(r.purpose)}</td>
                          <td>{r.day}</td>
                          <td>{r.time}</td>
                          <td>
                            <i className="fa fa-gbp me-1"></i> {r.amount}
                          </td>
                          <td>{r.min_duration ? `${r.min_duration} hrs` : '—'}</td>
                          <td>{r.effective_from || '—'}</td>
                          <td>{r.effective_to || '—'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            {amenities.length > 0 && (
              <div className="col-md-12 mb-4">
                <h5 className="mb-3">Amenities</h5>
                <div className="row g-3">
                  {amenities.map((a, idx) => (
                    <div key={idx} className="col-lg-4 col-md-6">
                      <div className="textblockdetails botstyle">{a}</div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            <div className="col-md-12 mb-4">
              <div className="textblockdetails botstyle">
                <h5>Terms & Conditions</h5>
               <div
                  dangerouslySetInnerHTML={{
                    __html: terms
                  }}
                />
              </div>
            </div>

            <div className="col-md-12 mb-4">
              <div className="textblockdetails botstyle">
                <h5>Instructions</h5>
                {/* <p>{instructions}</p> */} 
                  <div
                  dangerouslySetInnerHTML={{
                    __html: instructions
                  }}
                />
              </div>
            </div>

            <div className="col-md-12 mb-4">
              <div className="textblockdetails lcl-box">
                <h5>Advance Booking</h5>
                <p>{advanceBooking}</p>
              </div>
            </div>

            <div className="col-md-12">
              <div className="textblockdetails lcl-box">
                <h5>Cancellation Policy</h5>
                <div className="form-check">
                  <input
                    className="form-check-input checkbox"
                    type="checkbox"
                    checked={cancellationPolicy === "yes"}
                    readOnly
                  />
                  <label className="form-check-label">Refundable Policy</label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Modal
          show={showModal}
          onHide={() => setShowModal(false)}
          size="lg"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                <span>{name}</span>
                <strong>{fid}</strong>
              </div>
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Carousel>
              {images.map((img, idx) => (
                <Carousel.Item key={idx}>
                  <img
                    src={img}
                    alt={`Facility ${idx}`}
                    className="d-block w-100"
                    style={{
                      height: "380px",
                      objectFit: "cover",
                      borderRadius: "10px",
                    }}
                  />
                </Carousel.Item>
              ))}
            </Carousel>
          </Modal.Body>
        </Modal>
      </div>
    </main>
  );
};

export default FacilityData;
